import { PageController } from '@client/components/_core/layout/PageController';
import { CommunicationTemplateEdit } from '@client/components/communication-templates/CommunicationTemplateEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit communication template',
        },
    },
    params: {
        parse({ communicationTemplateId }) {
            return {
                communicationTemplateId: BigInt(communicationTemplateId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <CommunicationTemplateEdit action={['edit', Route.useParams().communicationTemplateId]} />
        </PageController>
    );
}
